import { add, addDays, isFriday } from 'date-fns'

export const repeatTypes = {
  REPEAT_DAILY: 'daily',
  REPEAT_WEEKDAYS: 'weekdahys',
  REPEAT_WEEKLY: 'weekly',
  REPEAT_BIWEEKLY: 'biweekly',
  REPEAT_MONTHLY: 'monthly',
  REPEAT_QUARTERLY: 'quarterly',
  REPEAT_SEMIANNUALLY: 'semiannually',
  REPEAT_ANNUALLY: 'annually',
  REPEAT_YEARLY: 'yearly'
}

export const repeatNexts = {
  [repeatTypes.REPEAT_DAILY] (schedule) {
    return add(schedule, { days: 1 })
  },
  [repeatTypes.REPEAT_WEEKDAYS] (schedule) {
    return isFriday(schedule) ? addDays(schedule, 3) : addDays(schedule, 1)
  },
  [repeatTypes.REPEAT_WEEKLY] (schedule) {
    return add(schedule, { days: 7 })
  },
  [repeatTypes.REPEAT_BIWEEKLY] (schedule) {
    return add(schedule, { days: 14 })
  },
  [repeatTypes.REPEAT_MONTHLY] (schedule) {
    return add(schedule, { months: 1 })
  },
  [repeatTypes.REPEAT_QUARTERLY] (schedule) {
    return add(schedule, { months: 3 })
  },
  [repeatTypes.REPEAT_SEMIANNUALLY] (schedule) {
    return add(schedule, { months: 6 })
  },
  [repeatTypes.REPEAT_ANNUALLY] (schedule) {
    return add(schedule, { years: 1 })
  },
  [repeatTypes.REPEAT_YEARLY] (schedule) {
    return add(schedule, { years: 1 })
  }
}
